<template>
  <v-container>
    <go-back-btn :routeToGo="'/'" />
    <PageHeader :title="title" class="mb-3" />
    <v-row>
      <!-- Filtros -->
      <v-col cols="12">
        <v-card flat class="mx-auto my-12 mt-2 mb-2" outlined>
          <v-container>
            <v-form
              v-model="isFormValid"
              ref="presentaciones-filters-form"
              id="presentaciones-filters-form"
              @submit.prevent="applyFilters()"
            >
              <v-row class="mt-2">
                <!-- fecha desde -->
                <v-col cols="3" md="3" class="py-0">
                  <v-menu
                    ref="fecha-presentaciones-desde"
                    v-model="menuFechaDesde"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechaDesdeSelected"
                        label="Fecha desde"
                        :append-icon="calendarIcon"
                        v-bind="attrs"
                        autocomplete="not"
                        hint="Formato DD/MM/AAAA"
                        @blur="fechaDesde = parseDateToIso(fechaDesdeSelected)"
                        outlined
                        dense
                        clearable
                        v-mask="'##/##/####'"
                        v-on="on"
                        :rules="[
                          (v) => {
                            if (!v) return true;
                            if (fechaDesdeSelected && fechaSelectedHasta) {
                              return (
                                new Date(parseDateToIso(fechaDesdeSelected)) <=
                                  new Date(
                                    parseDateToIso(fechaSelectedHasta)
                                  ) ||
                                'La fecha desde debe ser menor o igual a fecha hasta'
                              );
                            }
                            return true;
                          },
                          (v) => {
                            if (!v) return true;
                            return rules.validDate[0](v);
                          },
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fechaDesde"
                      no-title
                      @change="fechaDesdeSelected = formatDate(fechaDesde)"
                      @input="menuFechaDesde = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- fecha hasta -->
                <v-col cols="3" md="3" class="py-0">
                  <v-menu
                    ref="fecha-presentaciones-hasta"
                    v-model="menuFechaHasta"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechaSelectedHasta"
                        label="Fecha hasta"
                        :append-icon="calendarIcon"
                        v-bind="attrs"
                        autocomplete="not"
                        hint="Formato DD/MM/AAAA"
                        @blur="fechaHasta = parseDateToIso(fechaSelectedHasta)"
                        outlined
                        dense
                        clearable
                        v-mask="'##/##/####'"
                        v-on="on"
                        :rules="[
                          (v) => {
                            if (!v) return true;
                            if (fechaDesdeSelected && fechaSelectedHasta) {
                              return (
                                new Date(parseDateToIso(fechaDesdeSelected)) <=
                                  new Date(
                                    parseDateToIso(fechaSelectedHasta)
                                  ) ||
                                'La fecha desde debe ser menor o igual a fecha hasta'
                              );
                            }
                            return true;
                          },
                          (v) => {
                            if (!v) return true;
                            return rules.validDate[0](v);
                          },
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fechaHasta"
                      no-title
                      @change="fechaSelectedHasta = formatDate(fechaHasta)"
                      @input="menuFechaHasta = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- participante -->
                <v-col cols="3" class="py-0">
                  <v-text-field
                    v-model="participante"
                    label="Participante"
                    dense
                    outlined
                    :rules="[rules.noStartWithSpaces]"
                  ></v-text-field>
                </v-col>
                <!-- Observaciones -->
                <v-col cols="3" class="py-0">
                  <v-text-field
                    v-model="observaciones"
                    label="Observaciones"
                    dense
                    outlined
                    :rules="[rules.noStartWithSpaces]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mr-1 mt-n5">
                <v-col cols="12" class="pt-0 pr-0">
                  <v-btn
                    color="primary"
                    :disabled="!isFormValid"
                    small
                    class="to-right mt-1"
                    :dark="isFormValid"
                    type="submit"
                    form="presentaciones-filters-form"
                  >
                    Aplicar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" class="py-5">
        <v-data-table
          class="elevation-2"
          :headers="presentacionesHeaders"
          :items="presentacionesItems"
          :loading="loading"
          :search="search"
          :custom-sort="customSort"
          dense
          item-key="numeroPresentacion"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-row>
                <v-col cols="6" align-self="center">
                  <v-text-field
                    v-model="search"
                    clearable
                    label="Buscar"
                    single-line
                    :append-icon="iconoSearch"
                  ></v-text-field>
                </v-col>
                <v-col cols="3"></v-col>
                <v-col cols="3" align="end" class="pt-5">
                  <v-btn
                    color="primary"
                    class="to-right"
                    @click="openModalToEdit()"
                  >
                    Nuevo
                  </v-btn>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  size="20"
                  v-on="on"
                  @click="openModalDetalle(item)"
                >
                  {{ seeIcon }}
                </v-icon>
              </template>
              <span>Ver detalle</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  size="20"
                  v-on="on"
                  @click="openModalToEdit(item)"
                >
                  {{ editIcon }}
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  size="20"
                  v-on="on"
                  @click="openModalToCopy(item)"
                >
                  {{ copyIcon }}
                </v-icon>
              </template>
              <span>Copiar</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  size="20"
                  v-on="on"
                  @click="openDeletePresentaciones(item)"
                >
                  {{ deleteIcon }}
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-if="openModalEdit"
      v-model="openModalEdit"
      max-width="70%"
      persistent
      @keydown.esc="closeAndReload"
    >
      <EditPresentacion
        :presentacionEditItem="presentacionEditItem"
        :isDetalle="isDetalle"
        :isCopy="isCopy"
        @closeAndReload="closeAndReload"
      >
      </EditPresentacion>
    </v-dialog>
    <DeleteDialog
      max-width="43%"
      :titleProp="titleDelete"
      :openDelete.sync="showDeleteModalPresenta"
      :isLoading="isLoadingPresenta"
      @onDeleteItem="confirmDeletePresenta()"
    />
  </v-container>
</template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import { mapActions } from "vuex";
import enums from "@/utils/enums/index.js";
import GoBackBtn from "@/components/shared/GoBackBtn";
import rules from "@/utils/helpers/rules";
import EditPresentacion from "./EditPresentacion.vue";
import DeleteDialog from "@/components/shared/DeleteDialog";
import { mask } from "vue-the-mask";
export default {
  name: "Presentaciones",
  components: {
    PageHeader,
    GoBackBtn,
    EditPresentacion,
    DeleteDialog,
  },
  directives: { mask },
  data() {
    return {
      rules: rules,
      title: "Presentaciones",
      iconoSearch: enums.icons.SEARCH_ICON,
      editIcon: enums.icons.EDIT,
      deleteIcon: enums.icons.DELETE,
      calendarIcon: enums.icons.CALENDAR_ICON,
      seeIcon: enums.icons.SEE,
      copyIcon: enums.icons.COPY,
      titleDelete: "¿Desea eliminar la presentación?",
      enums: enums,
      participante: "",
      observaciones: "",
      menuFechaDesde: false,
      menuFechaHasta: false,
      fechaDesdeSelected: null,
      fechaSelectedHasta: null,
      fechaDesde: null,
      fechaHasta: null,
      search: "",
      loading: false,
      isFormValid: false,
      openModalEdit: false,
      showDeleteModalPresenta: false,
      isLoadingPresenta: false,
      isDetalle: false,
      isCopy: false,
      idPresentaToDelete: null,
      presentacionEditItem: {},
      presentacionesItems: [],
      presentacionesHeaders: [
        {
          text: "N° de presentación",
          align: "start",
          sortable: true,
          value: "numeroPresentacion",
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechaPres",
        },
        {
          text: "Observaciones",
          align: "start",
          sortable: false,
          value: "observaciones",
        },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.setFechaInicial();
  },
  methods: {
    ...mapActions({
      setAlert: "user/setAlert",
      getPresentaciones: "presentaciones/getPresentaciones",
      deletePresentacion: "presentaciones/deletePresentacion",
    }),
    setFechaInicial() {
      // fecha de hoy para seteo inicial de fecha hasta y desde
      let today = new Date();
      let año = today.getFullYear();
      let mes = today.getMonth() + 1;
      let dia = today.getDate();
      dia < 10 ? (dia = `0${dia}`) : dia;
      mes < 10 ? (mes = `0${mes}`) : mes; //para que el mes tenga dos digitos y lo reconozca el datepicker
      this.fechaHasta = `${año}-${mes}-${dia}`;
      this.fechaSelectedHasta = this.formatDate(this.fechaHasta);
      // seteo inicial de fecha desde
      let fechaDes = new Date(today);
      fechaDes.setDate(fechaDes.getDate() - 30);
      let añoDesde = fechaDes.getFullYear();
      let mesDesde = fechaDes.getMonth() + 1;
      let diaDesde = fechaDes.getDate();
      diaDesde < 10 ? (diaDesde = `0${diaDesde}`) : diaDesde;
      mesDesde < 10 ? (mesDesde = `0${mesDesde}`) : mesDesde;
      this.fechaDesde = `${añoDesde}-${mesDesde}-${diaDesde}`;
      this.fechaDesdeSelected = this.formatDate(this.fechaDesde);
    },
    async applyFilters() {
      this.$store.state.filtersPresentaciones == null;
      this.loading = true;
      const data = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        participante: this.participante == null ? "" : this.participante,
        observaciones: this.observaciones == null ? "" : this.observaciones,
      };
      this.filtrosGuardados = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        participante: this.participante,
        observaciones: this.observaciones,
      };
      const response = await this.getPresentaciones(data);
      this.presentacionesItems = response;
      this.loading = false;
    },
    openModalToEdit(item) {
      this.openModalEdit = true;
      this.isDetalle = false;
      this.isCopy = false;
      this.presentacionEditItem = item;
    },
    openModalDetalle(item) {
      this.openModalEdit = true;
      this.isDetalle = true;
      this.isCopy = false;
      this.presentacionEditItem = item;
    },
    openModalToCopy(item) {
      this.openModalEdit = true;
      this.isDetalle = false;
      this.isCopy = true;
      this.presentacionEditItem = item;
    },
    openDeletePresentaciones(item) {
      this.idPresentaToDelete = item.numeroPresentacion;
      this.showDeleteModalPresenta = true;
    },
    async confirmDeletePresenta() {
      this.isLoadingPresenta = true;
      try {
        const response = await this.deletePresentacion(this.idPresentaToDelete);
        if (response) {
          this.setAlert({ type: "success", message: "Eliminado con éxito." });
          this.showDeleteModalPresenta = false;
          this.applyFilters();
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingPresenta = false;
    },
    closeAndReload() {
      this.openModalEdit = false;
      this.isDetalle = false;
      this.isCopy = false;
      this.applyFilters();
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    customSort(items, sortBy, sortDesc) {
      if (!Array.isArray(sortBy) || sortBy.length === 0) return items;

      const toComparable = (key, value) => {
        if (key === "fechaPres") {
          const iso = this.parseDateToIso(value);
          return iso || "";
        }
        return value;
      };

      const compare = (a, b) => {
        if (a === b) return 0;
        if (a === null || a === undefined) return -1;
        if (b === null || b === undefined) return 1;
        if (typeof a === "number" && typeof b === "number") {
          return a - b;
        }
        const aStr = String(a);
        const bStr = String(b);
        return aStr.localeCompare(bStr);
      };

      const sorted = [...items].sort((a, b) => {
        for (let i = 0; i < sortBy.length; i++) {
          const key = sortBy[i];
          const desc = Array.isArray(sortDesc) ? sortDesc[i] : !!sortDesc;
          const aVal = toComparable(key, a[key]);
          const bVal = toComparable(key, b[key]);
          const result = compare(aVal, bVal);
          if (result !== 0) return desc ? -result : result;
        }
        return 0;
      });

      return sorted;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length === 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .myLabel {
  color: white;
}
.to-right {
  float: right;
}
ul {
  list-style: none;
}
</style>